import { render, staticRenderFns } from "./PreQuestion1.vue?vue&type=template&id=f276f7f8&scoped=true&"
import script from "./PreQuestion1.vue?vue&type=script&lang=js&"
export * from "./PreQuestion1.vue?vue&type=script&lang=js&"
import style0 from "./PreQuestion1.vue?vue&type=style&index=0&id=f276f7f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f276f7f8",
  null
  
)

export default component.exports